import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Button } from 'react-bootstrap'
import DataTable from 'react-data-table-component';
import moment from 'moment';
//import _ from 'lodash'
import Swal from 'sweetalert2'

import { addFilesToProject } from '../../actions/projects'
import { getFiles } from '../../actions/files'

import Loader from '../loader/Loader.component';


const toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 2000,
})
const columns = [
  {
    name: "Name",
    selector: "file_name",
    sortable: true,
    format: ({ file_name, file_color }) => (
      <span className='file'
        style={{
          "--color": `#${file_color}`,
          '--hover-color': file_color === 'ffffff' ? '' : `#${file_color}`,
          '--margin': file_color === 'ffffff' ? '10px' : `5px`
        }}
      >{file_name}</span>)
  },
  {
    name: "Notes",
    selector: "file_note",
    sortable: true,
    format: ({ file_note }) => <span className='tooltip' title={file_note}>{file_note}</span>,
    wrap: true
  },
  {
    name: "Tags",
    selector: "tags",
    format: ({ tags }) => (
      <span style={{ margin: '5px' }}>
        {tags.map((tag, index) => <span className='tag' key={index}>{tag}</span>)}
      </span>
    ),
    wrap: true
  }
  ,
  {
    name: "Created",
    selector: "date_created",
    sortable: true,
    format: row => (
      <span>
        {moment.unix(row.date_created).format("MM/DD/YYYY")},&nbsp;
        ({moment(moment.unix(row.date_created).format("MMDDYYYY"), 'MMDDYYYY').fromNow()})
      </span>
    )
  },
  {
    name: "Type",
    selector: "file_type",
    sortable: true
  },
  {
    name: "Size",
    selector: "file_size",
    sortable: true,
  }
];



class AddFiles extends Component {
  constructor(props) {
    super(props)

    this.state = {
      show: false,
      projectFiles: []
    }
    this.preSelectedFiles = ({ _id }) => this.props.projectFiles.indexOf(_id) !== -1
    this.selectedFiles = 0
  }
  async componentDidMount() {
    this.setState({
      show: this.props.showModal
    })
    await this.props.getFiles()

  }

  handleClose = () => {
    this.setState({
      show: false,
    })
    this.props.handleClose()
  }
  handleSelectedFiles = async ({ selectedCount, selectedRows }) => {
    let msg = ''
    msg = this.selectedFiles > selectedCount ? 'Unseleted File' : selectedCount === 1 ? `${selectedCount} File seleted` : `${selectedCount}  Files seleted`
    this.selectedFiles = selectedCount
    toast.fire({
      icon: 'success',
      title: msg
    })
    const selectedFileIds = selectedRows.map(({ _id }) => _id)
    console.log(selectedRows)
    this.setState({
      projectFiles: selectedFileIds
    })
    console.log(selectedFileIds)
    this.setState({ loadingFiles: true })
    await this.props.addFilesToProject(this.props.projectId, { files: selectedFileIds })
    this.setState({ loadingFiles: false })
  }
  render() {
    return (
      <React.Fragment>
        <Modal
          dialogClassName="modal-90w"
          show={this.state.show}
          onHide={this.handleClose}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <h4>Files</h4>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {!this.props.files ? <div className='relative-loader'><Loader /></div> :
              <DataTable
                columns={columns}
                data={this.props.files}
                defaultSortField="file_name"
                pagination
                highlightOnHover
                selectableRows
                selectableRowsNoSelectAll
                selectableRowSelected={this.preSelectedFiles}
                onSelectedRowsChange={this.handleSelectedFiles}
                progressPending={this.state.loadingFiles}
                progressComponent={<Loader />}
              />
            }
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleClose}>
              Close
          </Button>

          </Modal.Footer>
        </Modal>
      </React.Fragment>
    )
  }
}
const mapStateToProps = (state) => ({
  files: state.files.userFiles
})
export default connect(mapStateToProps, { getFiles, addFilesToProject })(AddFiles)